// import axios from "axios";
import React, { useContext, useEffect } from "react";
import Context from "../store/Context";
import axios from "axios";
import { useNavigate } from "react-router-dom";

function AdminUserList(props) {
  const connectionUrl = process.env.REACT_APP_BACKEND_URL;
  const user = JSON.parse(localStorage.getItem("token"));
  const navigate = useNavigate();
  const ctx = useContext(Context);
  const [allUsers, setAllUsers] = React.useState(ctx.allUser || []);
  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const response = await axios.post(`${connectionUrl}:${process.env.REACT_APP_BACKEND_PORT}/admin/getAllUser`, {
  //         token: user.access_token,
  //         domain: user.domain,
  //       });

  //       ctx.addUserData(response.data.users);

  //     } catch (err) {
  //       console.log(err);
  //     }
  //   };
  //   fetchData();
  // }, []);
  // const fetchUserDetails = async (id) => {
  //   try {
  //     const response = await axios.post(
  //       `${connectionUrl}/admin/getUser?id=${id}`,
  //       {
  //         token: user.access_token,
  //         domain: user.domain,
  //       }
  //     );
  //     ctx.AdminCurrentUser(response.data.user);
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };
  const searchHandler = (e) => {
    const searchTerm = e.target.value.toLowerCase();
    const filteredUsers = ctx.allUser.filter((user) =>
      (user.firstName + " " + user.lastName).toLowerCase().includes(searchTerm)
    );
    setAllUsers(filteredUsers);
  };
  const selectedTheme = "modern reeloizd";
  return (
    <section
      className={`${
        selectedTheme === "modern reeloid"
          ? "bg-black/40 backdrop-blur-lg "
          : "bg-[#2A3042] "
      } py-2  rounded-md  m-4 mt-8`}
    >
      <div className="flex justify-between p-4 border-b-2">
        <p className="text-white text-[1.2rem] font-bold">All User List</p>
        <input
          placeholder="Search user Here"
          className="px-2 rounded"
          onChange={searchHandler}
        ></input>
      </div>
      <div className="flex gap-6 flex-col xl:flex-row">
        <div
          className={` ${
            selectedTheme === "modern reeloid"
              ? "bg-black/40 backdrop-blur-lg "
              : "bg-[#2A3042] "
          } flex-1  rounded-md text-gray-200 max-md:overflow-auto py-2`}
        >
          <div className="font-normal text-[.9rem] min-w-[740px]">
            {/* <div className="font-semibold flex border-b pb-2 border-gray-500">
              <div className="w-[100px] flex flex-shrink-0 items-center">
                <p className="px-4">Id</p>
              </div>

              <div className="w-[100%] flex flex-shrink-1 min-w-[100px] mx-8">
                <p className="p-2">Name</p>
              </div>
              <div className="w-[180px] flex flex-shrink-0 items-center">
                <p className="px-4">Designation</p>
              </div>
              <div className="w-[240px] flex flex-shrink-0">
                <p className="p-2">Email</p>
              </div>
              <div className="w-[150px] flex flex-shrink-0">
                <p className="p-2">Mobile</p>
              </div>
            </div> */}
            <div className="max-h-[77vh] overflow-y-auto">
              <table className="w-full table-auto text-left text-sm text-gray-200 border-collapse">
                <thead className="bg-gray-800 text-gray-300 sticky top-0 z-10">
                  <tr>
                    <th className="p-3 w-[100px]">ID</th>
                    <th className="p-3 max-w-[200px] truncate">Name</th>
                    <th className="p-3 w-[380px]">Designation</th>
                    <th className="p-3 w-[240px]">Email</th>
                    <th className="p-3 w-[150px]">Mobile</th>
                  </tr>
                </thead>
                {allUsers?.length > 0 &&
                  allUsers.map((current, index) => (
                    // <div
                    //   className="hover:cursor-pointer hover:bg-yellow-600 font-normal flex my-2 text-gray-200 border-b border-gray-500  shadow-lg hover:scale-95 hover:shadow-xl transition-transform duration-200"
                    //   onClick={() => {
                    //     navigate(`${current.id}`);
                    //   }}
                    // >
                    //   <div className="w-[100px] px-2  flex-shrink-0">
                    //     <p className="p-2">{current.id}</p>
                    //   </div>
                    //   <div className="w-[100%]  flex-shrink-1 min-w-[100px] flex  items-center mx-8">
                    //     <p className="p-2">
                    //       {current.firstName + " " + current.lastName}
                    //     </p>
                    //   </div>{" "}
                    //   <div className="w-[180px] px-2  flex-shrink-0">
                    //     <p className="p-2">{current?.designation || "-"}</p>
                    //   </div>
                    //   <div className="w-[240px] flex flex-shrink-0">
                    //     <p className="p-2 text-wrap whitespace-normal break-words w-[100%]">
                    //       {current.email}
                    //     </p>
                    //   </div>
                    //   <div
                    //     className="w-[150px]  flex-shrink-0 flex  items-center justify-center cursor-pointer"
                    //     onClick={() => {
                    //       navigate(`/allMovies/`);
                    //     }}
                    //   >
                    //     {current.mobile || "-"}
                    //   </div>
                    // </div>

                    <tbody className="overflow-y-auto px-20">
                      <tr
                        className="hover:cursor-pointer hover:bg-yellow-600 border-b border-gray-600 transition-transform duration-200 hover:scale-95 hover:shadow-xl"
                        onClick={() => navigate(`${current.id}`)}
                      >
                        <td className="p-3 truncate">{current.id}</td>
                        <td className="p-3 truncate">
                          {current.firstName + " " + current.lastName}
                        </td>
                        <td className="p-3 truncate">
                          {current?.designation || "-"}
                        </td>
                        <td className="p-3 truncate">{current.email}</td>
                        <td
                          className="p-3 truncate text-center hover:underline"
                          onClick={(e) => {
                            e.stopPropagation(); // prevent row click
                            navigate("/allMovies/");
                          }}
                        >
                          {current.mobile || "-"}
                        </td>
                      </tr>
                    </tbody>
                  ))}
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AdminUserList;
